import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { WageBreakdownOrigin } from "../../utils/navigation/wageBreakdownReturn";
import { SystemBackButton } from "../UIToolkit/Navigation/SystemBackButton";
import { useWageBreakdownReturn } from "./useWageBreakdownReturn";

type Props = {
	/** How the page was arrived at (`useArrivalState`); nothing renders without it. */
	origin: WageBreakdownOrigin | undefined;
};

/**
 * DAT-906 · "Back to wage breakdown" on a page opened from a shift's breakdown: returns to that day
 * schedule with the breakdown open again. Rendered only for someone who arrived by a breakdown link.
 */
export const WageBreakdownReturnButton: FC<Props> = ({ origin }) => {
	const { t } = useTranslation();
	const onReturn = useWageBreakdownReturn(origin);
	if (onReturn === undefined) return null;
	return <SystemBackButton label={t("wageBreakdown.return")} size="small" onClick={onReturn} dataTestId="wage-breakdown-return-button" />;
};
